import { ieee, mla, mla7 } from './styleConstants'

export const generateTextList = [ieee, mla7, mla, 'mla-8']
export const generateTextDesc = (style: string): string => {
  const newstyle = style === 'MLA-8' ? 'MLA8' : style
  return `Generate ${newstyle} citations in seconds. Start citing books, websites, journals, and more with the Citation Machine® ${newstyle} Citation Generator.`
}
